import axios from "axios";

export const getEventMatches = async (event, team) => {
  try {
    const response = await axios.get(
      `https://www.thebluealliance.com/api/v3/event/${event}/matches`,
      {
        headers: {
          "X-TBA-Auth-Key":
            "awpaQWQYzO8lbvawU991yecembSfJzVj9lFK01yxZvVaYJTD6yTnsgl4mhlXXy1E",
        },
      }
    );

    if (!response.data) return [];
    if (team !== "") {
      const filteredMatches = response.data.filter((match) => {
        const redTeams =
          match.alliances?.red?.team_keys?.map((t) => t.replace("frc", "")) ||
          [];
        const blueTeams =
          match.alliances?.blue?.team_keys?.map((t) => t.replace("frc", "")) ||
          [];

        return redTeams.includes(team) || blueTeams.includes(team);
      });
      console.log(filteredMatches);
      return filteredMatches;
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching match data:", error.message);
    }
    return [];
  }
};
